import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import { getFirestore } from "./firebase";

const useFirestoreUpdate = (collection, docId) => {
  const db = getFirestore();

  // Function to format the date
  const formatDate = (timestamp) => {
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }).format(timestamp);
  };

  /** Firestore no acepta `undefined` en campos; `getUtmParams()` puede traer utm_* opcionales undefined. */
  const omitUndefined = (obj) =>
    Object.fromEntries(Object.entries(obj).filter(([, v]) => v !== undefined));

  const updateData = async (data) => {
    // Format the date before sending
    const formattedDate = formatDate(Date.now());

    const newEntry = omitUndefined({
      ...data,
      createdAt: formattedDate,
    });

    // `update` falla si el documento no existe (p. ej. colección nueva o doc borrado).
    // `set` + `merge` + `arrayUnion` crea el doc o agrega al array `datos`.
    await db
      .collection(collection)
      .doc(docId)
      .set(
        {
          datos: firebase.firestore.FieldValue.arrayUnion(newEntry),
        },
        { merge: true }
      );
  };

  return { updateData };
};

export default useFirestoreUpdate;
